// Shows a "Tia is typing" bubble in the TikiEffect chat widget while a customer waits for a reply.
// Load it after the chat widget script. It only reads the widget's own messages; it sends nothing.
(function () {
  var AVATAR = "https://assets.cdn.filesafe.space/wjvJWvFuKYnL3B4IGrsP/media/01697a2d-dd64-4cfc-b644-7718720a1128.png";
  var DELAY_MS = 900;      // pause before the dots appear, like a person picking up the chat
  var MAX_MS = 120000;     // stop showing the dots if no reply arrives within 2 minutes
  var SYSTEM_LINE = /will be right with you/i; // no longer shown, kept harmless
  var waitingSince = 0;
  var lastCount = -1;     // only react to messages sent after the page loaded

  function root() {
    var w = document.querySelector("chat-widget");
    return w && w.shadowRoot;
  }

  function lastDirection(pane) {
    var msgs = pane.querySelectorAll("chat-message");
    if (!msgs.length) return null;
    var sr = msgs[msgs.length - 1].shadowRoot;
    if (!sr) return null;
    if (sr.querySelector(".bubble.outgoing")) return "out";
    // the widget's own "Tia will be right with you" notice is not a reply, so keep the dots going
    if (SYSTEM_LINE.test(msgs[msgs.length - 1].textContent || "")) return "out";
    if (sr.querySelector(".bubble.incoming")) return "in";
    return null;
  }

  function addStyle(sr) {
    if (sr.getElementById("tia-typing-style")) return;
    var s = document.createElement("style");
    s.id = "tia-typing-style";
    s.textContent =
      "#tia-typing{display:flex;align-items:flex-end;gap:8px;padding:6px 16px 10px;}" +
      "#tia-typing img{width:30px;height:30px;border-radius:50%;object-fit:cover;}" +
      "#tia-typing .dots{background:#FBEBDD;border-radius:16px;padding:12px 14px;display:flex;gap:5px;}" +
      "#tia-typing .dots span{width:7px;height:7px;border-radius:50%;background:#AC761E;opacity:.35;animation:tiaBounce 1.2s infinite;}" +
      "#tia-typing .dots span:nth-child(2){animation-delay:.2s}#tia-typing .dots span:nth-child(3){animation-delay:.4s}" +
      "@keyframes tiaBounce{0%,60%,100%{transform:translateY(0);opacity:.35}30%{transform:translateY(-4px);opacity:1}}";
    sr.appendChild(s);
  }

  function show(pane, sr) {
    if (pane.querySelector("#tia-typing")) return;
    addStyle(sr);
    var el = document.createElement("div");
    el.id = "tia-typing";
    el.innerHTML = '<img alt="" src="' + AVATAR + '"><div class="dots"><span></span><span></span><span></span></div>';
    pane.appendChild(el);
    var conv = pane.shadowRoot && pane.shadowRoot.querySelector("chat-conversation");
    try { (conv || el).scrollIntoView ? el.scrollIntoView({ block: "end" }) : null; } catch (e) {}
  }

  function hide(pane) {
    var el = pane && pane.querySelector("#tia-typing");
    if (el) el.remove();
  }

  setInterval(function () {
    var sr = root();
    if (!sr) return;
    var pane = sr.querySelector("chat-pane");
    if (!pane) return;
    var count = pane.querySelectorAll("chat-message").length;
    var dir = lastDirection(pane);
    if (lastCount === -1) { lastCount = count; return; }
    var isNew = count > lastCount;
    lastCount = count;
    if (dir === "out" && (isNew || waitingSince)) {
      if (!waitingSince) waitingSince = Date.now();
      var waited = Date.now() - waitingSince;
      if (waited > DELAY_MS && waited < MAX_MS) show(pane, sr); else if (waited >= MAX_MS) hide(pane);
    } else {
      waitingSince = 0;
      hide(pane);
    }
  }, 300);
})();
